import { render, staticRenderFns } from "./AsmntTestcards.vue?vue&type=template&id=4312960a"
import script from "./AsmntTestcards.vue?vue&type=script&lang=js"
export * from "./AsmntTestcards.vue?vue&type=script&lang=js"
import style0 from "./AsmntTestcards.vue?vue&type=style&index=0&id=4312960a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports